export enum LoginEnum {
    Login = 1,
    ForgetPassword = 2,
    ResetPassword = 3, 
    EmailLinkSuccess = 4
}


// WEBPACK FOOTER //
// ./src/constants/Enum/LoginEnum.tsx